
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import StickyCTA from '../../components/feature/StickyCTA';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import DiferenciaisSection from './components/DiferenciaisSection';
import StartDateSection from './components/StartDateSection';
import FlexibilidadeSection from './components/FlexibilidadeSection';
import PilaresSection from './components/PilaresSection';
import EspecialistasSection from './components/EspecialistasSection';
import ModulosPreviewSection from './components/ModulosPreviewSection';
import InvestimentoSection from './components/InvestimentoSection';
import FAQSection from './components/FAQSection';
import InscricaoHomeSection from './components/InscricaoHomeSection';

export default function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <WhatIsSection />
        <DiferenciaisSection />
        <StartDateSection />
        <FlexibilidadeSection />
        <PilaresSection />
        <EspecialistasSection />
        <ModulosPreviewSection />
        <InvestimentoSection />
        <FAQSection />
        <InscricaoHomeSection />
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
}
